import {
  AsyncPropSelector,
  ALL_MODULES,
  Loader,
  getTranslatedText,
  useIntl,
  DEPENDENT_FIELD_MAP,
  DEPENDENT_FIELD_LABEL,
  DEFAULT_FIELDS_BY_COLUMN_NAME
} from '@nile/components';
import { AccountClient } from '@nile/graphql';
import React, { useState, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';
import { GET_FIELD } from '@nile/banyan/src/Graphql/Mutations/ticket';
import { DisplayText, Tippy } from '@superops/ui-design-system';
import { getCellValue } from '@nile/reports/src/modules/EfficiencyReport/util';
import { isEmpty } from 'lodash';

const DefaultFieldsInput = (props) => {
  const {
    field,
    value,
    onChange,
    appendTo,
    noPortalTarget,
    customLabelComponent,
    isUiDesignSystem,
    ticket,
    fields
  } = props;

  const { columnName, label, id } = field;

  const intl = useIntl();
  const [currentValue, setCurrentValue] = useState(value?.[columnName] || null);
  const currentValueByRef = React.useRef(null);
  currentValueByRef.current = currentValue;

  const dataTocheck = { ...ticket, ...ticket?.customFields, ...fields };
  const parentValue =
    getCellValue(dataTocheck, field?.parentField?.columnName) || null;

  const getOptions = async () => {
    const options = await AccountClient.query({
      query: GET_FIELD,
      variables: { input: { id: id, module: ALL_MODULES.ticket } }
    });
    return options;
  };

  const generateOptions = (f, data) => {
    let fldOptions = data?.getField?.options || data?.getField?.fieldOptions;
    if (!isEmpty(data?.getField?.parentField)) {
      const prntValue =
        typeof parentValue === 'object'
          ? parentValue?.name || parentValue?.id
          : parentValue;
      if (prntValue) {
        fldOptions = fldOptions?.filter(
          (el) => el?.parentOption?.value === prntValue
        );
      } else {
        fldOptions = [];
      }
    }

    const generatedOptions = fldOptions?.map((option) => ({
      name: option?.value,
      label: option?.value,
      value: option?.value
    }));

    return generatedOptions;
  };

  const updateSelection = (f, val) => {
    if (onChange && typeof onChange === 'function') {
      onChange(f, val);
    }
    setCurrentValue(val.value);
  };

  useEffect(() => {
    if (field?.parentField) {
      setCurrentValue(null);
    }
  }, [parentValue]);

  useEffect(() => {
    setCurrentValue(value?.[columnName] || null);
  }, [value]);

  const CustomLabelComponent = customLabelComponent;

  return (
    <div className="flex col g20">
      <Tippy
        title={
          field?.parentField?.columnName
            ? `${getTranslatedText(intl, 'common.admin.dependent.to')} ${
                field?.parentField?.label
              }`
            : undefined
        }
        position="bottom-end"
        delay={500}
      >
        <div className="fields-wrapper" key={label}>
          {CustomLabelComponent ? (
            <CustomLabelComponent label={label} />
          ) : (
            <DisplayText size="extraLarge" weight="Medium">
              {label}
            </DisplayText>
          )}

          <AsyncPropSelector
            defaultValue={
              currentValueByRef.current
                ? {
                    label: currentValueByRef.current,
                    name: currentValueByRef.current
                  }
                : ''
            }
            hideTitle
            isDynamicQuery
            dynamicQuery={getOptions}
            generateOptions={generateOptions}
            isDisabled={field?.parentField?.columnName && !parentValue}
            placeholder={
              field?.parentField?.columnName && !parentValue
                ? 'common.admin.depedant.field.choose.parent'
                : null
            }
            field={field}
            updateSelection={updateSelection}
            appendTo={appendTo}
            noPortalTarget={noPortalTarget}
            isUiDesignSystem={isUiDesignSystem}
          />
        </div>
      </Tippy>
    </div>
  );
};

export default DefaultFieldsInput;
